/* -----------------Child components--------------- */
import { CustomAppBar } from "@memorang/ui/components/CustomAppbar";

import { pageViewTypes } from "@constants/tracking";
import ProfileContainer from "@features/dashboard/screens/ProfileContainer";
/* -----------------Types--------------- */
import useAnalytics from "@hooks/useAnalytics";
import useAuthUser from "@hooks/useAuthUser";
import DocumentTitle from "components/DocumentTitle";
import { router } from "expo-router";

const ProfileRoute = () => {
	const { username } = useAuthUser();

	useAnalytics({
		type: pageViewTypes.profile,
	});

	return (
		<>
			<CustomAppBar
				title={username ?? ""}
				leftIconType="back"
				onPressBack={() => router.back()}
				hideCommandBar
			/>
			<DocumentTitle title="Profile" />
			<ProfileContainer />
		</>
	);
};

export default ProfileRoute;
